import { render, staticRenderFns } from "./_postIcon.vue?vue&type=template&id=0d360344&scoped=true"
import script from "./_postIcon.vue?vue&type=script&lang=js"
export * from "./_postIcon.vue?vue&type=script&lang=js"
import style0 from "./_postIcon.vue?vue&type=style&index=0&id=0d360344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d360344",
  null
  
)

export default component.exports